import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
    topSales: {
        id: 'listing.productCard.merchandizing.topSales.infos',
        defaultMessage:
            // eslint-disable-next-line formatjs/no-multiple-plurals, formatjs/no-camel-case, formatjs/enforce-plural-rules
            '<a href="https://www.manomano.fr/infos-consommateurs">Learn more about Top sales</a>',
        description: 'top sales informations of product card',
    },
    booster: {
        id: 'listing.productCard.merchandizing.booster.infos',
        defaultMessage:
            // eslint-disable-next-line formatjs/no-multiple-plurals, formatjs/no-camel-case, formatjs/enforce-plural-rules
            'These are advertisements for products sold on Manomano.fr. <a href="https://www.manomano.fr/infos-consommateurs">Learn more about sponsored products.</a>',
        description: 'tooltip booster informations of product card',
    },
});

const useTooltipContent = type => {
    const intl = useIntl();
    if (type === 'topSales') return intl.formatMessage(messages.topSales);
    if (['recommended', 'productOfTheWeek', 'sponsored'].includes(type))
        return intl.formatMessage(messages.booster);

    return undefined;
};

export default useTooltipContent;
